import { Content } from "antd/es/layout/layout";
import {
  Button,
  Form,
  Input,
  message,
  Rate,
  Switch,
  Typography,
  UploadFile,
} from "antd";
import { ReviewPageLoaderType } from "./loaders";
import { useFetcher, useLoaderData } from "react-router-dom";
import { useState } from "react";
import { getBase64 } from "~/utils/file";
import Upload, { RcFile } from "antd/es/upload";
import { UploadOutlined } from "@ant-design/icons";
import { useAppTranslation } from "~/hooks/useAppTranslation";

const { Title } = Typography;

const ReviewPage = () => {
  const _loaderData = useLoaderData() as ReviewPageLoaderType;
  const { t } = useAppTranslation();
  const [loading, setLoading] = useState(false);
  const fetcher = useFetcher();
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const handleSubmit = async (values: any) => {
    setLoading(true);

    if (values.images?.fileList && values.images.fileList.length > 0) {
      values.image = (
        await getBase64(values.images.fileList[0].originFileObj as RcFile)
      ).replace(/data:\w+\/\w+;base64,/, "");
      values.imageName = values.images.fileList[0].name;
    } else {
      values.image = null;
      values.imageName = null;
    }

    fetcher.submit(
      {
        body: JSON.stringify(values),
      },
      { method: "post" }
    );

    form.resetFields();
    setFileList([]);
    setLoading(false);
  };

  const beforeUpload = (file: RcFile) => {
    const isLessThan2M = file.size / 1024 / 1024 < 2;
    if (!isLessThan2M) {
      message.error("Image must be smaller than 2MB!");
      return Upload.LIST_IGNORE;
    }

    // prevent upload from submitting
    return false;
  };

  const handleFileChange = ({ fileList }: { fileList: UploadFile[] }) => {
    setFileList(fileList);
  };

  const [form] = Form.useForm();

  return (
    <Content>
      <div className="centered-form">
        <Title className="centered-form-title" level={1}>
          {t("Leave_a_Review")}
        </Title>
        <Form form={form} onFinish={handleSubmit}>
          <Form.Item>
            <Form.Item
              label={t("Review_Title")}
              name="title"
              rules={[
                {
                  required: true,
                  message: t("Please_enter_review_title"),
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={t("Review_Details")}
              name="details"
              rules={[
                {
                  required: true,
                  message: t("Please_enter_details"),
                },
              ]}
            >
              <Input.TextArea />
            </Form.Item>
            <Form.Item
              label={t("Rating")}
              name="rating"
              rules={[
                {
                  required: true,
                  message: t("Please_enter_rating"),
                },
              ]}
            >
              <Rate />
            </Form.Item>
            <Form.Item
              label={t("Would_you_recommend_living_here")}
              name="recommend"
            >
              <Switch />
            </Form.Item>
            <Form.Item label={t("Image_Upload")} name="images">
              <Upload
                maxCount={1}
                beforeUpload={beforeUpload}
                onChange={handleFileChange}
                fileList={fileList}
              >
                <Button icon={<UploadOutlined />}>
                  {t("Click_to_upload")}
                </Button>
              </Upload>
            </Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              {t("Submit")}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Content>
  );
};

export default ReviewPage;
